module.exports = __webpack_public_path__ + "media/images/logos/Temasek-Polytechnic-ae9ffa9048b56364b740c62c378afa60.svg";